module.exports = __webpack_public_path__ + "static/media/today.270246de.png";